// 취소 사유 7종 — 정본은 서버 utils/evalCancelReasons.js (docs/design/eval-cancel-reason/BUILD_PLAN.md §3).
// GET /api/eval/orders/cancel-reasons?scope=admin 이 실패하거나(미배포) 빈 배열을 주면 이 상수로 대체한다.
// 값은 §3 표를 글자 그대로 복사 — 오타 금지(앱·웹 문구 일치가 목표).
export var CANCEL_REASONS_ADMIN = [
  { code: 'UNIDENTIFIABLE_VEHICLE', needsResubmit: true,
    label: {
      ko: '매물을 특정할 수 없습니다. 매물 정보 화면 캡처 또는 링크를 첨부해 다시 신청해 주세요.',
      en: 'We could not identify the vehicle. Please reapply with a screenshot of the listing details page or its link.',
      ar: 'تعذّر تحديد المركبة. يُرجى إعادة الطلب مع إرفاق لقطة شاشة لصفحة بيانات الإعلان أو رابطه.',
      ru: 'Не удалось определить автомобиль. Подайте заявку повторно, приложив скриншот страницы с данными объявления или ссылку.'
    },
    short: { ko: '매물 특정 불가', en: 'Vehicle not identified', ar: 'تعذّر تحديد المركبة', ru: 'Авто не определено' } },
  { code: 'LISTING_GONE', needsResubmit: false,
    label: {
      ko: '해당 매물이 판매 완료되었거나 삭제되었습니다.',
      en: 'The listing has been sold or removed.',
      ar: 'تم بيع الإعلان أو حذفه.',
      ru: 'Объявление продано или удалено.'
    },
    short: { ko: '매물 판매완료·삭제', en: 'Listing gone', ar: 'الإعلان غير متاح', ru: 'Объявление снято' } },
  { code: 'DUPLICATE_REQUEST', needsResubmit: false,
    label: {
      ko: '동일 매물로 이미 신청된 건이 있습니다.',
      en: 'A request for the same listing already exists.',
      ar: 'يوجد طلب سابق لنفس الإعلان.',
      ru: 'Заявка на это объявление уже существует.'
    },
    short: { ko: '중복 신청', en: 'Duplicate request', ar: 'طلب مكرر', ru: 'Дубликат заявки' } },
  { code: 'OUT_OF_SERVICE_AREA', needsResubmit: false,
    label: {
      ko: '검차가 어려운 지역입니다. 담당자가 별도로 안내드립니다.',
      en: 'The vehicle is outside our inspection area. Our team will contact you.',
      ar: 'المركبة خارج نطاق الفحص لدينا. سيتواصل معك فريقنا.',
      ru: 'Автомобиль находится вне зоны нашего осмотра. Наша команда свяжется с вами.'
    },
    short: { ko: '검차 불가 지역', en: 'Outside service area', ar: 'خارج نطاق الخدمة', ru: 'Вне зоны осмотра' } },
  { code: 'INSPECTOR_UNAVAILABLE', needsResubmit: true,
    label: {
      ko: '요청하신 일정에 배정 가능한 평가사가 없습니다. 다른 일정으로 다시 신청해 주세요.',
      en: 'No inspector is available for the requested date. Please reapply with another date.',
      ar: 'لا يوجد مُقيِّم متاح في الموعد المطلوب. يُرجى إعادة الطلب بموعد آخر.',
      ru: 'На выбранную дату нет свободного эксперта. Подайте заявку повторно с другой датой.'
    },
    short: { ko: '평가사 배정 불가', en: 'No inspector available', ar: 'لا يوجد مُقيِّم', ru: 'Нет эксперта' } },
  { code: 'BUYER_REQUEST', needsResubmit: false,
    label: {
      ko: '신청자 요청으로 취소되었습니다.',
      en: "Cancelled at the applicant's request.",
      ar: 'أُلغي بناءً على طلب مُقدِّم الطلب.',
      ru: 'Отменено по запросу заявителя.'
    },
    short: { ko: '신청자 요청', en: "Applicant's request", ar: 'بطلب مُقدِّم الطلب', ru: 'По запросу заявителя' } },
  { code: 'OTHER', needsResubmit: false,
    label: {
      ko: '기타 사유로 취소되었습니다. 담당자가 별도로 안내드립니다.',
      en: 'Cancelled for another reason. Our team will contact you.',
      ar: 'أُلغي لسبب آخر. سيتواصل معك فريقنا.',
      ru: 'Отменено по другой причине. Наша команда свяжется с вами.'
    },
    short: { ko: '기타', en: 'Other', ar: 'أخرى', ru: 'Другое' } }
];

export function byCode(code) {
  var found = null;
  CANCEL_REASONS_ADMIN.forEach(function(r) { if (r.code === code) found = r; });
  return found;
}
